
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import contactforms from "@/models/contactforms";
import Banner from "../components/banner";
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import formtextarea from "../formcomponet/formtextarea.vue";


export default {
  mixins: [apibtoast, apigeneric, contactforms],
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
    forminput,
    formcombobox,
    formtextarea



  },

  data() {
    return {
      FormData: {},
      term: localStorage.getItem("searchTerm"),
      dataip: null,
      ConfigData: null,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      }



    };
  },
  created() {
    const url = "https://api.ipify.org/?format=json"
    fetch(url)
      .then(response => response.json())
      .then(data => this.dataip = data.ip);



  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "configs",
        Page: this.Page,
        Filter: "&Websiteid=" + window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.ConfigData = res.Data[0].Gonderimyapilacakepostalar;
      });



    },
    onSubmit() {
      if (this.ConfigData != null) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.FormData.Clientip = this.dataip
          this.FormData.Createdby = this.TokenUserId
          this.FormData.Created = new Date()
          this.FormData.Usertype = "0"
          this.FormData.Isreaded = false
          this.FormData.Websiteid = window.$cookies.get("ecampuswebsite")
          this.Post("contactforms", this.FormData)
          this.sendmail()

        }
      }
    },
    sendmail() {
      let MesajData = {
        Message: "Adı: " + this.FormData.Namesurname + " Kullanıcı IP: " + this.FormData.Clientip + " Mesaj: " + this.FormData.Message,
        Recievermailadress: this.ConfigData,
      };
      this.Post(this.$config.API_URL_2 + "mzneposta/sendinvite", MesajData)
    },


  },
};
</script>
    
<template>
  <Loader>
    <Layout>
      <Banner />
      <div class="graduates">
        <div class="container">
          <div class="table-graduate">
            <p class="h2 text-center cl-service-dark" style="margin-top: -50px;">{{$t("Contactforms.Title")}}</p>
            <div class="container">
              <template>
                <Form @submit.prevent="onSubmit">
                  <div class="row">
                    <div class="col-md-6 mx-auto mt-4">
                      <formcombobox :FormDataType="FormDataType.Messagetype" :Value="FormData.Messagetype"
                        :v="$v.FormData.Messagetype" @input="FormData.Messagetype = $event" />
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <forminput :FormDataType="FormDataType.Namesurname" :Value="FormData.Namesurname"
                        :v="$v.FormData.Namesurname" @input="FormData.Namesurname = $event" />
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <formcombobox :FormDataType="FormDataType.Gender" :Value="FormData.Gender" :v="$v.FormData.Gender"
                        @input="FormData.Gender = $event" />
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <forminput :FormDataType="FormDataType.Phone" :Value="FormData.Phone" :v="$v.FormData.Phone"
                        @input="FormData.Phone = $event" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <forminput :FormDataType="FormDataType.Email" :Value="FormData.Email" :v="$v.FormData.Email"
                        @input="FormData.Email = $event" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <forminput :FormDataType="FormDataType.Subject" :Value="FormData.Subject" :v="$v.FormData.Subject"
                        @input="FormData.Subject = $event" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mx-auto">
                      <formtextarea :FormDataType="FormDataType.Message" :Value="FormData.Message"
                        :v="$v.FormData.Message" @input="FormData.Message = $event" />
                    </div>
                  </div>
                  <button class="btn btn-primary" style="margin-left: 530px; width: 200px; height: 50px;" type="submit">
                    {{ $t("contactforms.Add.Button") }}
                  </button>
                </Form>
              </template>




            </div>
          </div>
        </div>
      </div>

    </Layout>
  </Loader>
</template>
    